<mat-icon [svgIcon]="getIconName()"></mat-icon>
